module.exports = __webpack_public_path__ + "public/Icons/smsIcon.svg?23c25d8b";